import { IconHouse, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

import { type ShippingLocation, ZIP_CODE_RANGE_OPERATOR } from 'typings'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
  RuleStack,
} from '../../../RuleStack'
import { RuleDefaultActions } from '../../../RuleStack/DefaultActions'
import { messages } from '../messages'
import { ShippingCountriesRule } from './ShippingCountriesRule'
import { ZipCodeRangesRule } from './ZipCodeRangesRule'

const { INCLUDE, EXCLUDE } = ZIP_CODE_RANGE_OPERATOR

type Props = {
  config: ShippingLocation
  onEdit: () => void
  onRemove: () => void
}

export function ShippingLocationView(props: Props) {
  const { config, onEdit, onRemove } = props
  const { $t } = useIntl()

  if (!config?.shippingCountries.length && !config.zipCodeRanges.length) return

  const { shippingCountries, zipCodeRanges } = config

  const inclusiveZipRanges = zipCodeRanges.filter(
    (range) => range.operator === INCLUDE
  )

  const exclusiveZipRanges = zipCodeRanges.filter(
    (range) => range.operator === EXCLUDE
  )

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconHouse />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <RuleStack>
          <ShippingCountriesRule shippingCountries={shippingCountries} />

          <ZipCodeRangesRule
            zipCodeRanges={inclusiveZipRanges}
            operator={INCLUDE}
          />

          <ZipCodeRangesRule
            zipCodeRanges={exclusiveZipRanges}
            operator={EXCLUDE}
          />
        </RuleStack>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
